import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { filterResults } from "../utils/functions";
import { useTheme } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  filter: {
    width: "100%",
    maxWidth: { xs: "100%", sm: 400, md: 500 },
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
}));

function QuickFilter(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { rows, columns, setFilteredRows, minWidth, marginTop } = props;
  const [filter, setFilter] = useState("");

  useEffect(() => {
    let result = rows;
    if (filter) {
      result = filterResults(filter || "", rows, columns);
    }
    setFilteredRows(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, rows]);

  const quickFilter = (ev) => {
    const val = ev.target.value;
    setFilter(val);
  };

  return (
    <TextField
      label="Quick filter"
      type="search"
      className={classes.filter}
      variant="outlined"
      size="small"
      style={{
        width: minWidth || "100%",
        marginTop: marginTop || theme.spacing(1),
        marginBottom: theme.spacing(0.5),
      }}
      onChange={quickFilter}
      value={filter}
    />
  );
}

export default QuickFilter;
